import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { REACT_APP_VMS_BASE_URL } from "../../utils/urls";

export const baseQuery = fetchBaseQuery({
  baseUrl: REACT_APP_VMS_BASE_URL,
});

const tagTypes = ["Visit"];

export const TRACE_API: any = createApi({
  reducerPath: "trace_server",
  refetchOnMountOrArgChange: 30,
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_VMS_BASE_URL,
    // prepareHeaders: (headers) => {
    //   const accessToken = localStorage.getItem("access_token");
    //   headers.set("Accept", "application/json");
    //   headers.set("Access-Control-Allow-Origin", "true");
    //   if (accessToken) headers.set("authorization", `Bearer ${accessToken}`);
    //   return headers;
    // },
    // credentials: "include",
  }),
  tagTypes: tagTypes,
  endpoints: (builder) => ({}),
  refetchOnFocus: true,
  refetchOnReconnect: false,
});

export const { endpoints, reducerPath, reducer, middleware } = TRACE_API;

export { tagTypes };

export default TRACE_API;
